/** @format */

// API 服务器地址

// console.log('node env-- in config-:', process.env.NODE_ENV, process.env.VUE_APP_API_SERVER)

export const API_SERVER = {
  default: window.VUE_APP_SERVER_CONFIG.VUE_APP_API_SERVER.endsWith('/')
    ? window.VUE_APP_SERVER_CONFIG.VUE_APP_API_SERVER
    : window.location.protocol + window.VUE_APP_SERVER_CONFIG.VUE_APP_API_SERVER + '/',
  imgBaseUrl:
    window.VUE_APP_FILE_SERVER ||
    (window.VUE_APP_SERVER_CONFIG.VUE_APP_FILE_SERVER.endsWith('/')
      ? window.VUE_APP_SERVER_CONFIG.VUE_APP_FILE_SERVER
      : window.VUE_APP_SERVER_CONFIG.VUE_APP_FILE_SERVER + '/'),
  otherBaseUrl: window.VUE_APP_SERVER_CONFIG.VUE_APP_OTHER_SERVER.endsWith('/')
    ? window.VUE_APP_SERVER_CONFIG.VUE_APP_OTHER_SERVER
    : window.VUE_APP_SERVER_CONFIG.VUE_APP_OTHER_SERVER + '/',
  defaultImg: 'static/images/default_car_image.jpg'
};

// 默认日期格式
export const DEFAULT_DATE_FORMAT = 'YYYY-MM-DD hh:mm:ss';
// export const MQTT_SERVER = isOEM ? cm || process.env.VUE_APP_CM_SERVER : process.env.VUE_APP_CM_SERVER
// export const MQTT_SERVER = process.env.VUE_APP_CM_SERVER
